export default __webpack_public_path__ + "static/SRF Carabrew 6GF6911 - Fiche de spécifications et données techniques-6dc93ff8cfdf3753552b57aa8e819cda.pdf";